import { Accordion, styled } from '@ltvco/refresh-lib/theme';

export const StyledAccordion = styled(Accordion)`
  .MuiSvgIcon-root {
    color: #9428c9;
  }
`;
